

export class EntityInfoBase {
    id!: number;
    ine10!: string;
    typeCode!: string;
    nameTypeCode!: string;
    name!: string;
    cif!: string;
    phone!: string;
    fax!: string;
    address!: string;
    postalCode!: string;
    town!: string;
    townCode!: string;
    region!: string;
    regionCode!: string;
    province!: string;
    provinceCode!: string;
    delegation!: string;
    delegationCode!: string;
    email!: string;
    updateDate!: string;

    static fromEntityInfo(entityType: EntityInfo): EntityInfoBase {

        let current = new EntityInfoBase();
        Object.assign(current, entityType)
            
        return current;
    }

    getNameInitialColorIndex():number{
        return EntityInfoBase.getIne10ToNumber(this.ine10)
        //return this.id%10
    }

    static  getIne10ToNumber(ine10:string|null):number{

        if (ine10 == null){
            return 0
        }

        const ine10ToNumber = Number(ine10)
        if (isNaN(ine10ToNumber) == true) {
            return 0
        }

        return parseInt(ine10) % 10
    }
}

export interface EntityInfo extends  EntityInfoBase{

}